import "./style.scss";

import IosSwitch from "components/shared/IosSwitch";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { fetchPeriods } from "store/periodStore";
import type { AppDispatch } from "store/store";
import { useAppSelector } from "store/store";

interface IStockSettings {
    hasEdited: () => void;
    useCompensationByDefault: number;
    onUseCompensationByDefault: (e: any) => void;
}

const CompanyPreferenceSettings = (props: IStockSettings) => {
    const { hasEdited, useCompensationByDefault, onUseCompensationByDefault } = props;
    const [t] = useTranslation();
    const dispatch = useDispatch<AppDispatch>();
    const { activePeriod } = useAppSelector((state) => state.period);

    useEffect(() => {
        !activePeriod && dispatch(fetchPeriods());
    }, [activePeriod, dispatch]);

    return (
        <div className="info-block stock-setting">
            <div className="info-block-head">
                <div className="info-block-head-name">{t("CompanySettings.Preference")}</div>
            </div>
            <div className="info-block-list">
                <div className="info-block-list-element show-stock-movement">
                    <span className="label">{t("CompanySettings.useCompensationByDefault")}</span>
                    <div className="switch">
                        <IosSwitch checked={!!useCompensationByDefault} onChange={onUseCompensationByDefault} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CompanyPreferenceSettings;
